import { runActive, type ProductGoal, type ProfileView } from "../../lib/productsApi";
import { shortDate } from "./text";

export type ProfileStep = "learning" | "question" | "draft" | "none";

/** Where a product's profile stands: confirmed or not, and what waits beyond the confirmed version. */
export function profileStatus(v: ProfileView): { confirmed: boolean; step: ProfileStep } {
  const step: ProfileStep =
    v.learnRun && runActive(v.learnRun.state) ? "learning" : v.draft?.question ? "question" : v.draft?.profile ? "draft" : "none";
  return { confirmed: v.confirmed !== null, step };
}

const PILLS: Record<string, [string, string]> = {
  setting_up: ["", "Setting up"],
  planning: ["live", "Planning"],
  plan_ready: ["tight", "Plan ready"],
  approved: ["live", "Getting ready"],
  getting_ready: ["live", "Getting ready"],
  live: ["live", "Running"],
  paused: ["tight", "Paused"],
  done: ["good", "Done"],
};

/** Whether the page a goal's Meta ads open on reports back, in the owner's words. */
export const TRACKING = { checked: "Tracking checked", not: "Tracking not checked yet", built_in: "Tracking built in" } as const;

/** A goal's state as the prototype's pill: its colour and its words. */
export const goalPill = (state: string): [string, string] => PILLS[state] ?? ["", state.replace(/_/g, " ")];

/**
 * A goal's line in a list, the prototype's way: what it wants and by when, from its own sentence, then how
 * many results so far against the number the sentence names.
 */
export function goalLine(g: ProductGoal): { title: string; sub: string | null } {
  const by = g.sentence.match(/\bby\s+(.+?)[.!]?$/i)?.[1] ?? null;
  const done = g.state === "done";
  const when = done && g.ended_at ? `ended ${shortDate(g.ended_at)}` : by ? `by ${by}` : null;
  const target = g.sentence.match(/\d[\d,]*/)?.[0];
  const n = g.results?.results;
  const progress = n === undefined ? null : target ? `${n} of ${target}${done ? "" : " so far"}` : `${n} so far`;
  return { title: g.sentence.replace(/\s*\bby\b.*$/i, "") || g.sentence, sub: [when, progress].filter(Boolean).join(" · ") || null };
}
